
import { Permission } from "../../types";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

/**
 * Initialize the database with default permissions if no data exists
 */
export const initializeDefaultPermissions = async (defaults: Permission[]): Promise<boolean> => {
  try {
    console.log("[PermissionsStorage] Initializing database with default permissions");
    
    // Check if permissions already exist to avoid duplicates
    const { data: existing, error: checkError } = await supabase
      .from('role_permissions')
      .select('id')
      .limit(1);
    
    if (checkError) {
      console.error("[PermissionsStorage] Error checking existing permissions:", checkError);
      return false;
    }
    
    // Only initialize if no data exists
    if (!existing || existing.length === 0) {
      // Important: We must remove numeric IDs to let Supabase generate proper UUIDs
      const cleanDefaults = defaults.map(({ id, ...rest }) => rest);
      
      const { error } = await supabase
        .from('role_permissions')
        .insert(cleanDefaults);
      
      if (error) {
        console.error("[PermissionsStorage] Error initializing default permissions:", error);
        toast.error("Fout bij initialiseren van rechten in database");
        return false;
      }
      
      console.log("[PermissionsStorage] Successfully initialized database with default permissions");
      return true;
    } else {
      console.log("[PermissionsStorage] Database already contains permissions, skipping initialization");
      return true;
    }
  } catch (error) {
    console.error("[PermissionsStorage] Error initializing default permissions:", error);
    toast.error("Fout bij initialiseren van rechten in database");
    return false;
  }
};
